import AOS from 'aos';
import { useEffect, useState } from 'react';
import './App.css';
import { getIarcPdfDocument, viewIarcPdfDocument } from './services/service';


function NoticeBox({ heading, text, date, link, delay, pdfFileOne, pdfFileTwo, visibilityDate }) {
    // Enter Visibility Date in format of MM/DD/YYY
    const lastDate = new Date(visibilityDate);
    lastDate.setDate(lastDate.getDate() + 3);

    const currentDate = new Date();

    if(lastDate < currentDate) {
        return;
    }

    const openPDFsInNewTabs = (e, pdf1, pdf2) => {
        e.preventDefault();
      
        pdf1 && window.open(pdf1, '_blank', 'noopener,noreferrer');
        pdf2 && window.open(pdf2, '_blank', 'noopener,noreferrer');
      };

    return (
        <a href={link} onClick={(e) => !link && openPDFsInNewTabs(e, pdfFileOne, pdfFileTwo)} target='_blank' rel='noreferrer noopener' className='flex justify-center h-full' data-aos='fade-up' data-aos-delay={delay}>
            <div className='notice-box h-full overflow-hidden flex flex-col'>
                <div className='assets flex items-center'>
                    <p className='m-auto font-bold text-xl heading text-center uppercase'>{heading}</p>
                </div>
                <div className='info-box h-full w-full grow px-4'>
                    <p className='notice font-bold text-center'>{text}</p>
                </div>
                <div className='info-box flex flex-col items-center p-10'>
                    <p className='date font-bold text-center mb-8'>{date}</p>
                    <img src='/assets/EAuction.svg' alt='IARC' style={{ width: "115px", height: '115px' }} />
                </div>
            </div>
        </a>
    );
}

const Asset = () => {
    const [pdfData, setPdfData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        AOS.init({
            duration: 1000
        });
    }, []);

    useEffect(() => {
        const getJobs = async () => {
          try {
            const res = await getIarcPdfDocument();

            if(res.success) {
                setPdfData(res.success.data);
            }
            setLoading(false);
          } catch (error) {
            setError(error.message);
            setLoading(false);
          }
        };
    
        getJobs();
      }, []);

    async function fetchFile(fileName) {
        try {
            const response = await viewIarcPdfDocument(fileName);
            if (response.success) {
                const fileUrl = response.success.preSignedUrl;
                if (fileUrl) {
                    window.open(fileUrl, '_blank');
                } else {
                    console.error('File URL is invalid or not provided');
                }
            } else {
                throw new Error('File not found or invalid response');
            }
        } catch (error) {
            console.error('Error fetching file:', error);
        }
    }


    return (
        <>
            <div className='h-20'></div>
            <div className='heading-rounded m-auto text-center text-white font-bold py-4 w-11/12 md:w-3/5'>
                Assets For Sale
            </div>
            <div className='container px-6 xl:px-0 xl:w-4/5 2xl:container mx-auto py-20 min-h-screen'>
                <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 mb-10 gap-6'>
                     <NoticeBox
                        text='Date of Auction - 25th September 2024'
                        link=''
                        heading='Sale Proclamation of Esvee Express Logistics Limited.'
                        date='EMD submission : 23th September 2024 before 3.00 pm'
                        delay='0'
                        pdfFileOne='/assets/pdf/Sale Proclamation-Date Of Auction 25.09.2024.pdf'
                        visibilityDate='09/26/2024'
                    />
                     <NoticeBox
                        text='Date of Auction - 27th September 2024'
                        link=''
                        heading='Sale Notice - Jayant Vitamins Ltd. (Ratlam, M.P)'
                        date='EMD submission : 27th September 2024 before 4.00 pm'
                        delay='0'
                        pdfFileOne='/assets/pdf/Jayant_vitamins_Sale Notice_Auction Dt 27.09.24.pdf'
                        visibilityDate='09/28/2024'
                    />
                     <NoticeBox
                        text='Date of Auction - 23rd September 2024'
                        link=''
                        heading='Sale Notice - JP Shaw (Thakurpukr, Kolkatta)'
                        date='EMD submission : 23rd September 2024 before 4.00 pm'
                        delay='0'
                        pdfFileOne='/assets/pdf/JP_Shaw_ Sale_Notice_Other_sale_docs.pdf'
                        visibilityDate='09/24/2024'
                    />
                     <NoticeBox
                        text='Date of Auction - 13th November 2024'
                        link=''
                        heading='Sale Notice - Kaushal Leather Board Ltd.(Raisen, M.P)'
                        date='EMD submission : 11th November 2024 before 5.00 pm'
                        delay='0'
                        pdfFileOne='/assets/pdf/Kaushal Leather Board_Sale Notice_Auction.pdf'
                        visibilityDate='11/14/2024'
                    />
                     <NoticeBox
                        text='Date of Auction - 8th January 2025'
                        link=''
                        heading='Sale Notice - Esvee Express Logistics Limited'
                        date='EMD submission : 6th January 2025 before 3.00 pm'
                        delay='0'
                        pdfFileOne='/assets/pdf/Esvee Express Logistics Limited.pdf'
                        visibilityDate='01/09/2025'
                    />
                    <NoticeBox
                        text='Date of Auction - 8th January 2025'
                        link=''
                        heading='PROPERTY IN PRIME LOCATION IN JIND, HARYANA AVAILABLE THROUGH E-AUCTION'
                        date='EMD submission : 06th January 2025 before 4.00 pm'
                        delay='0'
                        pdfFileOne='/assets/pdf/International Ceramics Ltd.pdf'
                        visibilityDate='01/09/2025'
                    />
                    <NoticeBox
                        text='Date of Auction - 15th May 2025'
                        link=''
                        heading='Sale Notice - Kaushal Leather Board Ltd.  (Raisen, M.P)'
                        date='EMD submission : 15th May 2025 before 5.00 pm'
                        delay='0'
                        pdfFileOne='/assets/pdf/Sale Proclamation-Kaushal Leather Board Ltd-17-03-2025.pdf'
                        visibilityDate='05/16/2025'
                    />
                    <NoticeBox
                        text='Date of Auction - 21th May 2025'
                        link=''
                        heading='Sale Notice - Sale of property at Bengaluru (Esvee Express Logistics Limited)'
                        date='EMD submission : 19th May 2025 before 5.00 pm'
                        delay='0'
                        pdfFileOne='/assets/pdf/Public notice for E-Auction sale - Esvee Express logistics 11.04.2025.pdf'
                        visibilityDate='05/22/2025'
                    />
                    <NoticeBox
                        text='Date of Auction - 11th June 2025'
                        link=''
                        heading='PROPERTY IN PRIME LOCATION IN RATLAM AVAILABLE THROUGH E-AUCTION BY DRT'
                        date='EMD submission : 9th June 2025 before 4.30 pm'
                        delay='0'
                        pdfFileOne='/assets/pdf/Sale_Notice_JVL.pdf'
                        visibilityDate='06/12/2025'
                    />
                    <NoticeBox
                        text='Date of Auction - 3rd October 2025'
                        link=''
                        heading='Sale of property at Karumathammpatti and Kaniyur village, Palladam Division, Coimbatore District'
                        date='EMD submission : 30th September 2025 before 5.00 pm'
                        delay='0'
                        pdfFileOne='/assets/pdf/Public_Notice_for_E_Auction_Term_and_Conditions_of_E-auction-19.08.2025.pdf'
                        visibilityDate='09/30/2025'
                    />
                     <NoticeBox
                        text='Date of Auction - 9th October 2025'
                        link=''
                        heading='Sale of property at Pollachi'
                        date='EMD submission : 7th October 2025 before 5.00 pm'
                        delay='0'
                        pdfFileOne='/assets/pdf/Madhavamani_Steels_E_auction_notice.pdf'
                        visibilityDate='10/07/2025'
                    />
                    {/* <NoticeBox
                        text='Date of Auction - 30th and 31st October 2025'
                        link=''
                        heading='PRIME PROPERTIES IN KANPUR, SANDILA & JHANSI AVAILABLE THROUGH E-AUCTION BY DRT - For more information 7770042174'
                        date='EMD submission : 21st October 2025 before 5.00 pm'
                        delay='0'
                        pdfFileOne='/assets/pdf/Sale_Notice_UPSTCL_Form 13.pdf'
                        visibilityDate='10/21/2025'
                    /> */}
                    <NoticeBox
                        text='Date of Auction - 14th November 2025'
                        link=''
                        heading='PROPERTY IN PRIME LOCATION IN RATLAM AVAILABLE THROUGH E-AUCTION BY DRT'
                        date='EMD submission : 12th November 2025 before 4.00 pm'
                        delay='0'
                        pdfFileOne='/assets/pdf/Jayant_vitamin_DRT Auction Notice dt 26.09.25 - Auction dt 14.11.25.pdf'
                        visibilityDate='11/12/2025'
                    />

                    <NoticeBox
                        text='Date of Auction - 27th November 2025'
                        link=''
                        heading='PRIME PROPERTIES IN JIND, HARYANA AVAILABLE THROUGH E-AUCTION BY DRT'
                        date='EMD submission : 25th November 2025 before 4.00 pm'
                        delay='0'
                        pdfFileOne='/assets/pdf/ICL Sale Notice_Publication.pdf'
                        visibilityDate='11/25/2025'
                    />


                    <NoticeBox
                        text='Date of Auction - 28th and 29th November 2025'
                        link=''
                        heading='PRIME PROPERTIES IN KANPUR, SANDILA & JHANSI AVAILABLE THROUGH E-AUCTION BY DRT'
                        date='EMD submission : 24th November 2025 before 5.00 pm'
                        delay='0'
                        pdfFileOne='/assets/pdf/Publication_Textile_Auction_Nov.pdf'
                        visibilityDate='11/24/2025'
                    />

                    <NoticeBox
                        text='Date of Auction - 24th December 2025'
                        link=''
                        heading='Sale of Property at Padmanabhanagar, Bengaluru'
                        date='EMD submission : 22nd December 2025 before 5.00 pm'
                        delay='0'
                        pdfFileOne='/assets/pdf/Notice dated 21.11.2025 V2.pdf'
                        visibilityDate='12/22/2025'
                    />

                    <NoticeBox
                        text='Date of Auction - 29th December 2025'
                        link=''
                        heading='PRIME PROPERTIES IN DELHI AVAILABLE THROUGH E-AUCTION - Nawada Delhi'
                        date='EMD submission : 26th December 2025 before 4.00 pm'
                        delay='0'
                        pdfFileOne='/assets/pdf/Prabhash jha.pdf'
                        visibilityDate='12/26/2025'
                    />
                       <NoticeBox
                        text='Date of Auction - 29th December 2025'
                        link=''
                        heading='PRIME PROPERTIES IN DELHI AVAILABLE THROUGH E-AUCTION - Mohan Garden Uttam Nagar Delhi'
                        date='EMD submission : 26th December 2025 before 4.00 pm'
                        delay='0'
                        pdfFileOne='/assets/pdf/Manoj Chawla.pdf'
                        visibilityDate='12/26/2025'
                    />
                       <NoticeBox
                        text='Date of Auction - 29th December 2025'
                        link=''
                        heading='PRIME PROPERTIES IN DELHI AVAILABLE THROUGH E-AUCTION - Raj Nagar Palam Delhi'
                        date='EMD submission : 26th December 2025 before 4.00 pm'
                        delay='0'
                        pdfFileOne='/assets/pdf/Harendra Chaudhary.pdf'
                        visibilityDate='12/26/2025'
                    />
                     <NoticeBox
                        text='Date of Auction - 29th December 2025'
                        link=''
                        heading='PRIME PROPERTIES IN DELHI AVAILABLE THROUGH E-AUCTION - Burari Delhi'
                        date='EMD submission : 26th December 2025 before 4.00 pm'
                        delay='0'
                        pdfFileOne='/assets/pdf/Satish Kumar Pandey.pdf'
                        visibilityDate='12/26/2025'
                    />

                    <NoticeBox
                        text='Date of Auction - 8th January 2026'
                        link=''
                        heading='Sale of Property at Talegaon - Pune Maharashtra'
                        date='EMD submission : 6th January 2026 before 4.00 pm'
                        delay='0'
                        pdfFileOne='/assets/pdf/BABAN_PANDURANG_NANAWARE_ talegaon.pdf'
                        visibilityDate='01/06/2026'
                    />

                    <NoticeBox
                        text='Date of Auction - 8th January 2026'
                        link=''
                        heading='Sale of Property at Nasirabad-Ajmer-Rajasthan'
                        date='EMD submission : 6th January 2026 before 4.00 pm'
                        delay='0'
                        pdfFileOne='/assets/pdf/DINESH_ nasirabad.pdf'
                        visibilityDate='01/06/2026'
                    />

                    <NoticeBox
                        text='Date of Auction - 8th January 2026'
                        link=''
                        heading='Sale of Property at North 24 Parganas-Kolkata-West Bengal'
                        date='EMD submission : 6th January 2026 before 4.00 pm'
                        delay='0'
                        pdfFileOne='/assets/pdf/GOPAL_SHAW_ parganas.pdf'
                        visibilityDate='01/06/2026'
                    />

                    <NoticeBox
                        text='Date of Auction - 8th January 2026'
                        link=''
                        heading='Sale of Property at Thane-Badlapur-Maharashtra'
                        date='EMD submission : 6th January 2026 before 4.00 pm'
                        delay='0'
                        pdfFileOne='/assets/pdf/VIKRAMAJEET_INAROO_RAM_ thane.pdf'
                        visibilityDate='01/06/2026'
                    />
                    <NoticeBox
                        text='Date of Auction - 8th January 2026'
                        link=''
                        heading='Sale of Property at Talegaon-Pune Maharashtra'
                        date='EMD submission : 6th January 2026 before 4.00 pm'
                        delay='0'
                        pdfFileOne='/assets/pdf/MADHUKAR_YEDU_BHALERAO_ talegaon.pdf'
                        visibilityDate='01/06/2026'
                    />
                    <NoticeBox
                        text='Date of Auction - 8th January 2026'
                        link=''
                        heading='Sale of Property at Virar-Maharashtra'
                        date='EMD submission : 6th January 2026 before 4.00 pm'
                        delay='0'
                        pdfFileOne='/assets/pdf/NITESH_DATTATRAY_SANDUPATL_virar.pdf'
                        visibilityDate='01/06/2026'
                    />
                    <NoticeBox
                        text='Date of Auction - 8th January 2026'
                        link=''
                        heading='Sale of Property at Raigad-Badlapur-Maharashtra'
                        date='EMD submission : 6th January 2026 before 4.00 pm'
                        delay='0'
                        pdfFileOne='/assets/pdf/SHABBIR_BASHIR_KHAN_Raigad_badlapur.pdf'
                        visibilityDate='01/06/2026'
                    />
                    <NoticeBox
                        text='Date of Auction - 8th January 2026'
                        link=''
                        heading='Sale of Property at New Shahhed Udham Singh Nagar-Amritsar-Punjab'
                        date='EMD submission : 6th January 2026 before 4.00 pm'
                        delay='0'
                        pdfFileOne='/assets/pdf/shahhed_udham_singh_nagar_punjab.pdf'
                        visibilityDate='01/06/2026'
                    />
                    <NoticeBox
                        text='Date of Auction - 16th January 2026'
                        link=''
                        heading='Sale of Property at Teh Sanganeer - Jaipur - Rajasthan'
                        date='EMD submission : 15th January 2026 before 4.00 pm'
                        delay='0'
                        pdfFileOne='/assets/pdf/Mr. Tulsiram Gurjar.pdf'
                        visibilityDate='01/15/2026'
                    />
                    <NoticeBox 
                        text='Date of Auction - 16th January 2026'
                        link=''
                        heading='Sale of Property at Teh Depalpur - Indore - Madhya Pradesh'
                        date='EMD submission : 15th January 2026 before 4.00 pm'
                        delay='0'
                        pdfFileOne='/assets/pdf/Mr. Rahul Subhash Dhandar.pdf'
                        visibilityDate='01/15/2026'
                    />
                    
                    <NoticeBox text='Date of Auction - 20th January 2026' link='' heading='Sale of Property at Jaipur - Rajasthan' date='EMD submission : 19th January 2026 before 4.00 pm' delay='0' pdfFileOne='/assets/pdf/Mr_VIkas_Kumar.pdf' visibilityDate='01/19/2026' />

                    <NoticeBox text='Date of Auction - 20th January 2026' link='' heading='Sale of Property at Noida - Uttar Pradesh' date='EMD submission : 19th January 2026 before 4.00 pm' delay='0' pdfFileOne='/assets/pdf/Mr_Venkata_Viswanath_Chadalavada.pdf' visibilityDate='01/19/2026' />

                    <NoticeBox text='Date of Auction - 20th January 2026' link='' heading='Sale of Property at Pune - Maharashtra' date='EMD submission : 19th January 2026 before 4.00 pm' delay='0' pdfFileOne='/assets/pdf/Mr_Kunal_Shahaji_Pratap.pdf' visibilityDate='01/19/2026' />

                    <NoticeBox text='Date of Auction - 20th January 2026' link='' heading='Sale of Property at Noida - Uttar Pradesh' date='EMD submission : 19th January 2026 before 4.00 pm' delay='0' pdfFileOne='/assets/pdf/Mr_Vivek_Singh.pdf' visibilityDate='01/19/2026' />

                    <NoticeBox text='Date of Auction - 28th January 2026' link='' heading='Sale of Property at Vijaywada - Andhra Pradesh' date='EMD submission :27th January 2026 before 4.00 pm' delay='0' pdfFileOne='/assets/pdf/Mrs_Janaki_Chitturi.pdf' visibilityDate='01/27/2026' />

                    <NoticeBox text='Date of Auction - 20th January 2026' link='' heading='Sale of Property at Pune - Maharashtra' date='EMD submission : 19th January 2026 before 4.00 pm' delay='0' pdfFileOne='/assets/pdf/Mr_Swapnil_Shankar_More.pdf' visibilityDate='01/19/2026' />

                    <NoticeBox text='Date of Auction - 20th January 2026' link='' heading='Sale of Property at Ahmedabad - Gujarat' date='EMD submission : 19th January 2026 before 4.00 pm' delay='0' pdfFileOne='/assets/pdf/Mr_Piyush_Bipinbhai_Parmar.pdf' visibilityDate='01/19/2026' />

                    <NoticeBox text='Date of Auction - 28th January 2026' link='' heading='Sale of Property at Ratlam - Madhya Pradesh' date='EMD submission : 27th January 2026 before 4.00 pm' delay='0' pdfFileOne='/assets/pdf/Mr_Rajesh.pdf' visibilityDate='01/27/2026' />

                    <NoticeBox text='Date of Auction - 20th January 2026' link='' heading='Sale of Property at Junagadh - Gujarat' date='EMD submission : 19th January 2026 before 4.00 pm' delay='0' pdfFileOne='/assets/pdf/Mr_Manish_Balubhai_Chudasama.pdf' visibilityDate='01/19/2026' />

                    <NoticeBox text='Date of Auction - 20th January 2026' link='' heading='Sale of Property at Vijapur - Gujarat' date='EMD submission : 19th January 2026 before 4.00 pm' delay='0' pdfFileOne='/assets/pdf/Mr_Rayabhanji_Mansangji_Thakor.pdf' visibilityDate='01/19/2026' />

                    <NoticeBox text='Date of Auction - 20th January 2026' link='' heading='Sale of Property at Pune - Maharashtra' date='EMD submission : 19th January 2026 before 4.00 pm' delay='0' pdfFileOne='/assets/pdf/Mr_Rehman_Issak_Sagari.pdf' visibilityDate='01/19/2026' />

                    <NoticeBox text='Date of Auction - 20th January 2026' link='' heading='Sale of Property at Jalandhar - Punjab' date='EMD submission : 19th January 2026 before 4.00 pm' delay='0' pdfFileOne='/assets/pdf/Mr_Shatruhan_Pathak.pdf' visibilityDate='01/19/2026' />


                    <NoticeBox text='Date of Auction - 19th January 2026' link='' heading='Sale of Property at UTTAM NAGAR - DELHI' date='EMD submission : 15th January 2026 before 4.00 pm' delay='0' pdfFileOne='/assets/pdf/IL10242747_Mr_Abhishek_Gupta.pdf' visibilityDate='01/15/2026' />
                    
                    {pdfData?.map((pdf, index) => (
                        pdf.is_deleted && (
                            <div className='flex items-center justify-center'>
                                <div
                                key={index}
                                className='notice-box h-full overflow-hidden flex flex-col justify-center items-center w-[375px]'
                                onClick={() => fetchFile(pdf.attached_file)}
                            >
                                <div className='assets flex items-center'>
                                    <p className='m-auto font-bold text-xl heading text-center'>{pdf.title}</p>
                                </div>
                                <div className='info-box h-full w-full grow px-4'>
                                    <p className='notice font-bold text-center'>Date of Auction - {pdf.auction_date}</p>
                                </div>
                                <div className='info-box flex flex-col items-center p-10'>
                                    <p className='date font-bold text-center mb-8'>EMD submission - {pdf.emd_submission}</p>
                                    <img src='/assets/EAuction.svg' alt='IARC' style={{ width: "115px", height: '115px' }} />
                                </div>
                            </div> 
                            </div>
                        )
                    ))}

                </div> 
            </div>
        </>
    );
}

export default Asset;